import { render, staticRenderFns } from "./navbarAuth.vue?vue&type=template&id=37d205ec"
var script = {}
import style0 from "./navbarAuth.vue?vue&type=style&index=0&id=37d205ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports